import { render } from "./WtbCheckBox.vue?vue&type=template&id=0b548df6"
import script from "./WtbCheckBox.vue?vue&type=script&lang=js"
export * from "./WtbCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__